import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetDataService } from '../../services/getdata.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-lab-sample',
  templateUrl: './lab-sample.component.html',
  styleUrls: ['./lab-sample.component.css']
})
export class LabSampleComponent implements OnInit {

  sampleDetails:{type:string,location:string,id:string,status:string,testAssigned:string,cartId:string,onGoingTest:string,dateOfCollection:string,
    details:{task:string,location:string,result:string}[]}= {
      type:'',
      location:'',id:'',status:'',testAssigned:'',cartId:'',onGoingTest:'',
      dateOfCollection:'',
      details:[]
    };
  
  id:string;
  constructor(private activatedRoute:ActivatedRoute,private dataService:GetDataService,private ngxservice:NgxUiLoaderService) { 
    this.activatedRoute.queryParams.subscribe(response=>{
      if(response && response.id){
        this.id = response.id;
        this.getSampleDetailsById(this.id);
      }
    })
  }

  ngOnInit(): void {
  }

  getSeperator(value:string){
    if(value && value.length>0){
      return ", ";
    }
    return "";
  }

  getSampleDetailsById=(id:string)=>{
    this.ngxservice.start();
    this.dataService.getSampleDetailsByID(id).subscribe(response=>{
      if(response && response.status_code && response.data && response.data.length>0){
        const sample = response.data[0];
        const testAssigned  =  response.data[0].tests_assigned && response.data[0].tests_assigned.length>0?response.data[0].tests_assigned:[];
        let locations='';
        let test='';
        let onGoing='';
        let details:{task:string,location:string,result:string}[] = [];
        testAssigned.forEach((item:any)=>{
          if(item.on_going){
            onGoing = onGoing + this.getSeperator(onGoing) + item.test_name;
          }
          test = test +  this.getSeperator(test) + item.test_name;
          locations = locations +  this.getSeperator(locations) + item.test_location;
          details.push({task:item.test_name,location:item.test_location,result:item.result});
        })
        this.sampleDetails = {
          type:sample.sample_id_type, location:locations,id:this.id,status:sample.status,testAssigned:test,
          cartId:sample.cart_id,onGoingTest:onGoing,
          dateOfCollection:sample.date_of_collection,
          details:details
        };
      }
      this.ngxservice.stop();
    },error=>{
      console.error('error while getting sample details by id',error);
      this.ngxservice.stop();
    })
  }

}
